import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { addToConfig, getTotalPages } from './utils';
import CropOptionsPrepaySelector from '../products/regular/subcomponents/CropOptionsPrepaySelector';
import { MOBILE_L } from '../hooks/screen';

const CropOptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
  width: 100%;

  @media (max-width: ${MOBILE_L}px) {
    padding: 15px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
  width: 100%;
  justify-content: center;

  @media (max-width: ${MOBILE_L}px) {
    flex-direction: column;
  }
`;

const ActionButton = styled.button`
  border: none;
  background: #479de3;
  color: white;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
  min-width: 120px;
  transition: background-color 0.2s ease;

  &:hover {
    background: #3885d3;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }

  @media (max-width: ${MOBILE_L}px) {
    width: 100%;
    padding: 14px 24px;
  }
`;

const CropOptions = ({ location, history }) => {
  const dispatch = useDispatch();
  const shoot = useSelector((state) => state.shoot);
  const productConfig = useSelector((state) => state.v3Order.productConfig);
  const additionalData = useSelector((state) => state.additionalData);

  const cropOptions = shoot?.crop_options || [];
  const currentIndex = parseInt(location.pathname.split('/').pop());
  const configItem = productConfig[currentIndex];
  const product = configItem?.product;
  const posesCount = product?.poses_count || 1;

  const productCropOptionsEnabled = product?.crop_options_enabled !== false;

  const [cropSelections, setCropSelections] = useState([]);
  const [skipTriggered, setSkipTriggered] = useState(false);

  // Auto-skip if no crop options available, product has no poses, or product has crop options disabled
  useEffect(() => {
    if (
      !skipTriggered &&
      (cropOptions.length === 0 ||
        !product ||
        posesCount === 0 ||
        !productCropOptionsEnabled)
    ) {
      setSkipTriggered(true);
      const pages = getTotalPages(shoot, additionalData);
      addToConfig({
        dispatch,
        history,
        productConfig,
        pages,
        itemToAdd: [],
        event: shoot,
      });
    }
  }, [
    cropOptions,
    product,
    posesCount,
    skipTriggered,
    productCropOptionsEnabled,
    shoot,
    additionalData,
    productConfig,
    dispatch,
    history,
  ]);

  if (!product || cropOptions.length === 0 || !productCropOptionsEnabled) {
    return null;
  }

  const allSelected = cropSelections.filter(Boolean).length >= posesCount;

  const handleContinue = () => {
    const pages = getTotalPages(shoot, additionalData);
    addToConfig({
      dispatch,
      history,
      productConfig,
      pages,
      itemToAdd: cropSelections.filter(Boolean),
      event: shoot,
    });
  };

  return (
    <CropOptionsWrapper>
      <CropOptionsPrepaySelector
        cropOptions={cropOptions}
        posesCount={posesCount}
        cropSelections={cropSelections}
        onCropSelectionsChange={setCropSelections}
      />
      <ButtonWrapper>
        <ActionButton onClick={handleContinue} disabled={!allSelected}>
          Continue
        </ActionButton>
      </ButtonWrapper>
    </CropOptionsWrapper>
  );
};

export default withRouter(CropOptions);
